// extracted by mini-css-extract-plugin
module.exports = {"root":"BasicInfoForm_root__ZGka7"};